<template>
  <div>
    <a-upload name="file" action="" @remove="() => false" :accept="accept" :maxCount="props.maxCount"
      :beforeUpload="beforeUpload" :showUploadList="false" v-model:file-list="fileList">
      <a-button type="primary" ghost>
        <span style="color: rgb(30, 142, 242);cursor: pointer;">{{ updateTitle }} <loading-outlined v-if="updateStatus=='上传中'"/></span>
      </a-button>
    </a-upload>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, defineExpose } from 'vue'
import { uploadOneFile } from "@/api/upload.js";
import { message, Upload } from "ant-design-vue";
const props = defineProps({
  pathName: {
    type: String,
    default: ''
  },
  // .doc, .docx, .jpeg, .jpg, .png, .xls, .xlsx
  accept: {
    type: String,
    default: ''
  },
  maxCount: {
    type: Number,
    default: 1
  },
  updateTitle: {
    type: String,
    default: '上传'
  },
  info:{
    type: Object,
  },
  title:{
    type: String,
    default: ''
  }
})
let fileList = ref([])
let updateTitle=ref("选择上传");
let updateStatus=ref("");

const emits = defineEmits(['uploadFinished'])

// 文件体转化
const convertFormData = (data) => {

  let folder = Date.now().toString();
  const json = {
    bucketName: "testing-management-private",
    pathName: props.pathName+'/'+folder, // 上传服务器路径，以项目模块名定义 如 test_project test_task
  };
  const formData = new FormData();
  formData.append("uploadFile", data);
  formData.append(
    "json",
    new Blob([JSON.stringify(json)], { type: "application/json" })
  );
  console.log(formData);
  return formData;
};

const beforeUpload = (file, fileList) => {
  if (props.accept !== '') {
    const docsArr = props.accept?.split(',').map(type => type.toLowerCase());
    const fileType = file.name.split(".");
    const fileDate = fileType.slice(-1);
    console.log(`.${fileDate[0]}`);
    console.log(docsArr);
    console.log(docsArr.includes(`.${fileDate[0]}`));
    if (!docsArr.includes(`.${fileDate[0].toLowerCase()}`)) {
      message.error(`仅支持${props.accept}文件格式！`);
      return Upload.LIST_IGNORE;
    }
  }
  uploadOneFile(convertFormData(file)).then(res => {
    emits('uploadFinished', res.data,props.info,props.title)
    updateTitle.value="重新上传"
      updateStatus.value="完成";
  }).catch(err => {
    message.error(`上传失败${err}`)
  })


  // uploadFile.value = file;
  return false;
};

const clearFileList = () => {
  fileList.value = []
}

defineExpose({
  clearFileList,
})



</script>

<style lang="less" scoped></style>
